@import 'apps/webcomponents/src/assets/common.scss';

gz-labeled-content {
  height: auto;
}

gz-tab {
  overflow: hidden auto;
  padding: 0 var(--spacer) 0 0;
}

.details-panel-wrapper {
  padding: var(--spacer);
  height: 100%;

  .details-panel {
    padding: calc(2 * var(--spacer));
    height: 100%;
    display: flex;
    flex-direction: column;

    .details-panel-header {
      margin-bottom: calc(3 * var(--spacer));
      color: var(--body-text-arrows-400);
      width: calc(100% - 2 * var(--spacer));

      .title {
        word-break: break-word;
      }
    }

    .details-panel-content-title {
      text-transform: uppercase;
    }

    .section-title {
      color: var(--chart-300-icon-buttons);
    }

    table {
      width: 100%;
    }

    .details-panel-details-wrapper {
      padding-top: var(--spacer);
      height: inherit;
      width: 100%;
      border-top: 1px solid var(--chart-100-pressed);
      display: flex;
      flex-direction: column;
    }

    .details-panel-actions {
      position: absolute;
      bottom: calc(3 * var(--spacer));
      display: flex;
    }
    & > gz-collapsable-container {
      padding-bottom: var(--spacer);
    }
    gz-labeled-content::part(content) {
      font-size: var(--body-size);
    }
  }
}

gz-table::part(table-row) {
  border-bottom: none;
}
gz-table::part(table-row-icon) {
  display: block;
  text-align: center;
  color: var(--chart-300-icon-buttons);
}
gz-table::part(cell-value) {
  font-weight: 400;
  color: var(--main-titles-inputs-600);
}
gz-flexible-table {
  height: 100%;
  margin-top: calc(2 * var(--spacer));
}
gz-flexible-table::part(clip-cell) {
  position: relative;
  flex: 1;
}

gz-flexible-table::part(select-icon) {
  position: absolute;
  right: 0;
  top: -2px;
}

gz-json-viewer {
  --row-height: 24px;
}

gz-button[class='confirmationButton'] {
  &::part(button-text) {
    text-transform: lowercase;
  }
}
